/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react'
import {KTSVG, toAbsoluteUrl} from '../../../helpers'
import {Dropdown1} from '../../content/dropdown/Dropdown1'

type Props = {
  cardColor: string,
  className: string,
  titleClass: string,
  title: string,
  link: string,
  count: string,
}


const LinkWidget: React.FC<Props> = (props) => {
  const {cardColor,className,title,titleClass,link,count} = props;
  const countCheck = count ? "justify-content-between" : "justify-content-center";
  return (
    <a href={link} className={className} style={{height:"75px",background:cardColor}}>
      {/* begin::Header */}
        <div className={'card-title d-flex align-items-center text-center mb-0 w-100 '+countCheck}>
          <span className={titleClass}>{title}</span>
          {count ?
          <span className="badge badge-warning">{count}</span>
          : null
          } 
        </div>  
      {/* end::Header */}
    </a>
  )
}

export {LinkWidget}
